export const START_LOAD = 'teams/START_LOAD';
export const FINISH_LOAD = 'teams/FINISH_LOAD';

const initialState = {
    loading:false,
    teams:null
};
export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
        case START_LOAD:  return {...state, loading:true};
        case FINISH_LOAD:  return {...state, loading:false, teams:action.payload};
        default: return state;
    }
}